module.exports = __webpack_public_path__ + "img/metrics.aa1f2c04.svg";